export const STARTED = 'STARTED';
export const FAILED = 'FAILED';
export const SUCCEEDED = 'SUCCEEDED';
